// eslint-disable-next-line import/no-unresolved
import DetailM06 from 'features/MidtermReview/pages/DetailM06';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function MidtermReviewDetailM06Page() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <DetailM06 />
      </Layout>
    </LayoutProvider>
  );
}

export default MidtermReviewDetailM06Page;
